import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const HeartAdd = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g>
        <g>
          <g>
            <path
              d="M17.2004 22.4076C19.8513 22.4076 22.0004 20.2586 22.0004 17.6076C22.0004 14.9566 19.8513 12.8076 17.2004 12.8076C14.5494 12.8076 12.4004 14.9566 12.4004 17.6076C12.4004 20.2586 14.5494 22.4076 17.2004 22.4076Z"
              stroke={stroke}
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <g>
              <path
                d="M18.9902 17.6675H15.4102"
                stroke={stroke}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.1992 15.9175V19.5074"
                stroke={stroke}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </g>
          <g>
            <path
              d="M22 9.09784C22 11.0678 21.49 12.8078 20.69 14.3178C19.81 13.3878 18.57 12.8079 17.2 12.8079C14.55 12.8079 12.4 14.9578 12.4 17.6078C12.4 18.8378 12.87 19.9579 13.63 20.8079C13.26 20.9779 12.92 21.1178 12.62 21.2178C12.28 21.3378 11.72 21.3378 11.38 21.2178C8.48 20.2278 2 16.0978 2 9.09784C2 6.00784 4.49 3.50781 7.56 3.50781C9.37 3.50781 10.99 4.38785 12 5.73785C13.01 4.38785 14.63 3.50781 16.44 3.50781C19.51 3.50781 22 6.00784 22 9.09784Z"
              stroke={stroke}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

HeartAdd.displayName = 'HeartAdd';
